import { render } from "./ModalDoctorSend.vue?vue&type=template&id=c2f30ab0&scoped=true"
import script from "./ModalDoctorSend.vue?vue&type=script&lang=js"
export * from "./ModalDoctorSend.vue?vue&type=script&lang=js"

import "./ModalDoctorSend.vue?vue&type=style&index=0&id=c2f30ab0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2f30ab0"]])

export default __exports__